import { ChartType } from './chartType';
import {AssetType} from './asset-type';
import {DataModuleType} from './data-module-type.type';
import {DataType} from './data-type.enum';
import {Data} from '@angular/router';
import {Filter} from './filter';
import {PermissionInterface} from '../../shared/components/permissions/models/permissions-map.type';
import {ColumnType} from './columnType.model';
import {ChartInteractionType} from './chart-interaction.type';
import {SliderControllerProperties} from './slider-controller-properties';
import {ControllerValue} from './controller-value.model';
import {ChartColumnType} from './chartColumn.type';
import {DrillThroughType} from './drill-through.type';
import {DrillThroughFilterType} from './drill-through-filter.type';
import {ColumnAggregationType} from './columnAggregationType';
import {ParameterProperties} from './parameterProperties.model';
import {DateControllerDefaultType} from './date-controller-default.type';
import {AdvanceSingleDate} from './advance-single-date.model';
import {AdvanceRangeDate} from './advance-range-date.model';
import { CalenderType } from './calender.type';
import { DefaultValueDateListController } from './default-value-date-list-controller.model';
import { ChartAnnotationSetting } from './chart-annotation-setting.model';
import { RelativeRangeDate } from './relative-range-.model';

export enum Categories {
  chart,
  controller
}

export interface FormatShow {
  formatType: FormatType;
  decimalPointNumber: number;
  negativeNumberFormat: string;
  hasSeparator: boolean;
  hasDollarSign: boolean;
  hasPercentSign: boolean;
  applyPercentage: boolean;
  currencyType: string;
  calenderType: CalenderType;
  dateTimeFormatType: string;
}

export type FormatType = 'None' | 'Default' | 'Number' | 'Currency' | 'Time' | 'Date' | 'String' | 'DateTime';
export type DrillingType = 'None' | 'ColumnDrillDown' | 'ChartDrillDown' | 'DrillToDetails';

export interface DescriptorColumn {
  priority: number;
  name: string;
  formatShow: FormatShow;
  dataSourceId: string;
  columnId: string;
  isAscending: boolean;
  id: string;
  dataModuleType?: DataModuleType;
  dataType: DataType;
  columnDataType?: DataType;
  columnDataModuleType?: DataModuleType;
  columnType?: ColumnType;
  parameterProperty?: boolean;
  columnName?: string;
  columnAggregationType?: string;
  columnIsMissed?: boolean;
  originalName?: string;
  originalDataSourceName?: string;
  showAsPercentageOfTotal?: boolean;
  parameterProperties?: ParameterProperties;
  hasError: boolean;
  errorMessage: string;
  mapFilePath?: string;
  mapId?: string;
  drillLevel?: number;
}

export interface ValueColumn {
  priority: number;
  name: string;
  formatShow: FormatShow;
  dataSourceId: string;
  columnId: string;
  columnAggregationType: string;
  showAsPercentageOfTotal: boolean;
  id: string;
  dataModuleType?: DataModuleType;
  dataType?: DataType;
  columnDataType?: DataType;
  columnDataModuleType?: DataModuleType;
  columnType?: ColumnType;
  parameterProperty?: boolean;
  colors?: any;
  originalName?: string;
  originalDataSourceName?: string;
  conditionalFormatting?: Partial<{
    backgroundColor: Partial<ConditionalFormattingColor>;
    valueColor: Partial<ConditionalFormattingColor>;
  }>;
  columnIsMissed?: boolean;
  hasError: boolean;
  errorMessage: string;
  drillLevel?: number;
}

export interface ConditionalFormattingColor {
  columnHasBackgroundColorFormat?: boolean;
  columnHasValueColorFormat?: boolean;
  formatType: 'None' | 'ColorScale';
  baseDataSourceId: string;
  baseColumnId: string;
  columnAggregationType: IColumnAggregationType;
  hasDiverging: boolean;
  hasCustomMin: boolean;
  hasCustomMiddle: boolean;
  hasCustomMax: boolean;
  minColor: string;
  middleColor: string;
  maxColor: string;
  minValue: number;
  middleValue: number;
  maxValue: number;
  noneValueDefaultFormat: 'None' | 'NoChange' | 'Zero';
  applyToOption: 'None' | 'Cell' | 'Total' | 'CellAndTotal';
}


export interface LegendColumn {
  priority: number;
  name: string;
  formatShow: FormatShow;
  dataSourceId: string;
  columnId: string;
  id: string;
  dataModuleType?: DataModuleType;
  dataType?: DataType;
  columnDataType?: DataType;
  columnType?: ColumnType;
  columnDataModuleType?: DataModuleType;
  parameterProperty?: boolean;
  columnAggregationType?: string;
  columnName?: string;
  columnIsMissed?: boolean;
  originalName?: string;
  originalDataSourceName?: string;
  hasError: boolean;
  errorMessage: string;
  drillLevel?: number;
}


export interface SecondValueColumn {
  priority: number;
  name: string;
  formatShow: FormatShow;
  dataSourceId: string;
  columnId: string;
  columnAggregationType: string;
  showAsPercentageOfTotal: boolean;
  id: string;
  dataModuleType?: DataModuleType;
  columnDataType?: DataType;
  dataType?: DataType;
  columnDataModuleType?: DataModuleType;
  columnType?: ColumnType;
  parameterProperty?: boolean;
  columnIsMissed?: boolean;
  originalName?: string;
  originalDataSourceName?: string;
  hasError: boolean;
  errorMessage: string;
}

export interface ChartDataSettings {
  descriptorColumns: Partial<DescriptorColumn>[];
  valueColumns: Partial<ValueColumn>[];
  legendColumns: Partial<LegendColumn>[];
  secondValueColumns: Partial<SecondValueColumn>[];
  sourceNameColumns: Partial<ValueColumn>[];
  targetNameColumns: Partial<ValueColumn>[];
  sourceGroupColumns: Partial<ValueColumn>[];
  sourceGroupNameColumns: Partial<ValueColumn>[];
  targetGroupColumns: Partial<ValueColumn>[];
  targetGroupNameColumns: Partial<ValueColumn>[];
  tooltipColumns: Partial<ValueColumn>[];
  // sortColumns: Partial<ChartInteractiveSort>[];
}

export interface ChartInteractiveSort {
  dataSourceId: string;
  columnId: string;
  isAscending: boolean;
  hasSort: boolean;
  name: string;
  columnDataModuleType: DataModuleType;
  isDeleted: boolean;
  columnDataType: DataType;
  dashboardId: string;
  isDashboardCalculateColumn: boolean;
  columnType?: ColumnType;
  parameterProperty?: boolean;
  columnIsMissed?: boolean;
  priority?: number;
  id?: string;
  dataModuleType?: DataModuleType;
}

export interface ColumnData {
  totalValue?: string;
  dataSourceId: string;
  columnId: string;
  columnName: string;
  id: string;
  data: string[];
  chartColumnType: ChartColumnType;
  dataType?: string;
  dataModuleType?: string;
  isHighlightColumn?: boolean;
  priority?: number;
  colors?: any;
  additionalData?: any;
  isConditionalFormattingColumn: boolean;
  conditionalFormattingValue?: {
    minValue?: number;
    averageValue?: number;
    maxValue?: number;
  };
  columnAggregationType?: ColumnAggregationType;
  mapFilePath?: string;
}

export interface InteractionStatus {
  dashboardId: string;
  chartId: string;
  interactStatusType: ChartInteractionType;
}

export interface DrillThroughProperties {
  isInteractableWithPages: boolean;
  interactionWithPagesType: DrillThroughType;
  destinationURL: string;
  destinationDashboardId: string;
  destinationWorkspaceId: string;
  // interactionWithPagesFilterType: DrillThroughFilterType;
  interactionWithPagesFilterTypes: DrillThroughFilterType[];
  // interactionWithPagesFilterType: DrillThroughFilterType;
  dashboardName: string;
}

export interface DefaultValuesForController {
  defaultValues: any[];
  hasDefaultValue: boolean;
  defaultValueType: DateControllerDefaultType;
  defaultValueAdvancedSingle: AdvanceSingleDate;
  defaultValueAdvancedRange: AdvanceRangeDate;
  defaultValueDateList: DefaultValueDateListController;
  defaultValueRelative: RelativeRangeDate;
}

export interface DrillingFilterValue {
  drilledChartId: string;
  dataSourceId: string;
  columnId: string;
  value: string;
}

export interface DrillingProperties {
  drillLevel: number;
  drillingType: DrillingType[];
  drillDownRealColumns: string[];
  drillDownShowColumns: string[];
  drillingFilterValues: DrillingFilterValue[];
}

export interface ChartModel {
  chartId: string;
  dashboardId: string;
  workspaceId: string;
  assetType: AssetType;
  imagePath: string;
  linkAddress: string;
  name: string;
  richName: string;
  pureName: string;
  inactive: boolean;
  chartType: ChartType;
  chartDataSettings: ChartDataSettings;
  chartDesignSettings: any;
  chartAnnotationSettings: ChartAnnotationSetting;
  chartInteractiveSort: Partial<ChartInteractiveSort>;
  permissions: number[];
  columnsData: ColumnData[];
  filters: Filter[];
  chartUserSort: Partial<ChartInteractiveSort>;
  hasError: boolean;
  noDataExist: boolean;
  needToReload: boolean;
  isController: boolean;
  paginationValues: any;
  hasTotalRow: boolean;
  hasSubTotalRow: boolean;
  hasTotalColumn: boolean;
  hasSubTotalColumn: boolean;
  isInteractableWithCharts: boolean;
  otherChartsInteractionStatusWithThis:  InteractionStatus[];
  permissionsResponseMap: PermissionInterface;
  sliderControllerProperties: SliderControllerProperties;
  controllersValues: Partial<ControllerValue>[];
  interactionWithPagesProperties: Partial<DrillThroughProperties>;
  defaultValuesForController: DefaultValuesForController;
  mapId: string;
  mapFilePath: string;
  mapTopo: any;
  colorSetId: number;
  chartHasBackgroundColorFormat: boolean;
  chartHasDomainColorFormat?: boolean;
  drillingProperties: Partial<DrillingProperties>;
  chartIndexInDashboard: number;
  isLoading: boolean;
  numberDisplayType: NumberDisplayType;
  blankValueDisplayType: BlankValueDisplayType;
  offlineMapServerUrl: string;
  result?: any;
  errorMessage: string;
  interactionRowIndex?: any;
  interactionEvent?: any;
  totalRowCount?:number;
  sortChartColumns: Partial<ChartInteractiveSort>[];
  lastModifiedDataSourceTickTime:string;
  hasDefaultDatasource: boolean;
}

export type IColumnAggregationType = 'None' | 'Sum' | 'Avg' | 'Median' | 'Count' | 'DistinctCount' | 'Min' | 'Max' |
  'StandardDeviation' | 'Variance' | 'NoAggregation' | 'NoAggregationForMeasure';

export type NumberDisplayType = 'fa' | 'en-US';
export type BlankValueDisplayType = 'default' | 'blank' | 'null' | 'dash' | 'notAvailable' | 'zero' | 'withoutValue';
